{
  "search_count": "Search {count} {noun}",
  "nouns": { "used": "cars", "truck": "vans", "motorcycle": "motorcycles" },
  "tabs": { "truck": "Vans" },
  "search_reassurance": "No commission. Call the seller directly.",
  "call": "Call",
  "whatsapp": "WhatsApp",
  "message": "Send message",
  "unspecified": "Not specified by the seller",
  "passenger_total": "passenger cars and SUVs",
  "hero_active": "{count} active listings.",
  "hero_direct": "Call the seller directly.",
  "trust_active": "{count} active listings",
  "trust_dealers": "{count} verified dealers",
  "trust_commission": "0% commission for buyers",
  "sort_label": "Sort by",
  "sort_options": { "newest": "Recently added", "price_asc": "Price: low to high", "price_desc": "Price: high to low", "year_desc": "Year: newest first", "mileage_asc": "Mileage: low to high" }
}